import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { AngularMultiSelectModule } from "angular2-multiselect-dropdown";
import { AaProfileComponent } from "projects/assessment-agency-v1/src/app/assessment-agency-v1/aa-profile/aa-profile.component";
import { CandidateFeedbackComponent } from "projects/candidate/src/app/candidate/feedback/candidate-feedback/candidate-feedback.component";
import { CpacFormComponent } from "projects/candidate/src/app/candidate/feedback/cpac-form/cpac-form.component";
import { TpFeedBackFormComponent } from "projects/candidate/src/app/candidate/feedback/tp-feed-back-form/tp-feed-back-form.component";
import { TrainerFeedbackFormComponent } from "projects/candidate/src/app/candidate/feedback/trainer-feedback-form/trainer-feedback-form.component";
import { BatchAttendenceComponent } from "projects/candidateattendence/src/app/candidateattendence/batch-attendence/batch-attendence.component";
import { ChangePasswordComponent } from "projects/change-spoc/src/app/change-spoc/change-password/change-password.component";
import { ChangeSpocComponent } from "projects/change-spoc/src/app/change-spoc/change-spoc/change-spoc.component";
import { AaAuditTrailComponent } from "projects/common/src/app/aa-audit-trail/aa-audit-trail.component";
import { AaDetailsComponent } from "projects/common/src/app/aa-details/aa-details.component";
import { AddressFormComponent } from "projects/common/src/app/address-form/address-form.component";
import { AddressComponent } from "projects/common/src/app/address/address.component";
import { ApplicantAddCertificateComponent } from "projects/common/src/app/applicant-add-certificate/applicant-add-certificate.component";
import { ApplicantAdvanceCertificationComponent } from "projects/common/src/app/applicant-advance-certification/applicant-advance-certification.component";
import { ApplicantCertificationListComponent } from "projects/common/src/app/applicant-certification-list/applicant-certification-list.component";
import { ApplicantPreferencesComponent } from "projects/common/src/app/applicant-preferences/applicant-preferences.component";
import { BreadcrumsComponent } from "projects/common/src/app/breadcrums/breadcrums.component";
import { CommonHeadersComponent } from "projects/common/src/app/common-header/common-headers.component";
import { DFormArrayComponent } from "projects/common/src/app/d-form-array/d-form-array/d-form-array.component";
import { DFormGroupComponent } from "projects/common/src/app/d-form-group/d-form-group.component";
import { DFormInputComponent } from "projects/common/src/app/d-form-input/d-form-input.component";
import { DFormComponent } from "projects/common/src/app/d-form/d-form.component";
import { DashboardCardComponent } from "projects/common/src/app/dashboard-card/dashboard-card.component";
import { DashboardTitleComponent } from "projects/common/src/app/dashboard-title/dashboard-title.component";
import { DashboardComponent } from "projects/common/src/app/dashboard/dashboard.component";
import { DatePickerComponent } from "projects/common/src/app/date-picker/date-picker.component";
import { DisplayResultComponent } from "projects/common/src/app/display-result/display-result.component";
import { EvidenceSubmissionComponent } from "projects/common/src/app/evidence-submission/evidence-submission.component";
import { ExpoSearchBoxComponent } from "projects/common/src/app/expositoy-shared/expo-search-box/expo-search-box.component";
import { FacilitySelectUploadAddingTcComponent } from "projects/common/src/app/facility-select-upload-adding-tc/facility-select-upload-adding-tc.component";
import { FileDownloadComponent } from "projects/common/src/app/file-download/file-download.component";
import { FileUploadComponent } from "projects/common/src/app/file-upload/file-upload.component";
import { AddCourseToSectorComponent } from "projects/common/src/app/forms/add-course-to-sector/add-course-to-sector.component";
import { AddSectorTargetFormComponent } from "projects/common/src/app/forms/add-sector-target-form/add-sector-target-form.component";
import { AddSectorTargetComponent } from "projects/common/src/app/forms/add-sector-target/add-sector-target.component";
import { AddSectorComponent } from "projects/common/src/app/forms/add-sector/add-sector.component";
import { AddingTcComponent } from "projects/common/src/app/forms/adding-tc/adding-tc.component";
import { LinkAssessorComponent } from "projects/common/src/app/forms/link-assessor/link-assessor.component";
import { LinkTrainerComponent } from "projects/common/src/app/forms/link-trainer/link-trainer.component";
import { PhoneEmailOtpVerificationComponent } from "projects/common/src/app/forms/phone-email-otp-verification/phone-email-otp-verification.component";
import { ReviewCommentsComponent } from "projects/common/src/app/forms/review-comments/review-comments.component";
import { ViewTcPhotosThroughMobileApkReviewAndSubmitComponent } from "projects/common/src/app/forms/view-tc-photos-through-mobile-apk-review-and-submit/view-tc-photos-through-mobile-apk-review-and-submit.component";
import { GenericDirective } from "projects/common/src/app/generic.directive";
import { GeoLocationComponent } from "projects/common/src/app/geo-location/geo-location.component";
import { ImageSliderComponent } from "projects/common/src/app/image-slider/image-slider.component";
import { InfoWidgetGroupComponent } from "projects/common/src/app/info-widget-group/info-widget-group.component";
import { InfoWidgetComponent } from "projects/common/src/app/info-widget/info-widget.component";
import {
  AadharComponent,
  CheckboxComponent,
  DateDurationComponent,
  DGeoLocationComponent,
  InputGroupComponent,
  MultiTabTableComponent,
  RadioComponent,
  SelectComponent,
  SimpleTextComponent,
  TableTwoComponent,
  TextComponent,
  UploadComponent,
} from "projects/common/src/app/input";
import { TableComponent } from "projects/common/src/app/input/table/table.component"
import { MprListComponent } from "projects/common/src/app/mpr-list/mpr-list.component";
import { PaginationTwoComponent } from "projects/common/src/app/pagination-two/pagination-two.component";
import { PaginationComponent } from "projects/common/src/app/pagination/pagination.component";
import { ReviewTypeComponent } from "projects/common/src/app/review-type/review-type.component";
import { SearchApplicantComponent } from "projects/common/src/app/search-applicant/search-applicant.component";
import { SearchResultForApplicantComponent } from "projects/common/src/app/search-result-for-applicant/search-result-for-applicant.component";
import { SearchComponent } from "projects/common/src/app/search/search.component";
import { SelectStateDistrictsComponent } from "projects/common/src/app/select-state-districts/select-state-districts.component";
import { StripedRowsTableComponent } from "projects/common/src/app/striped-rows-table/striped-rows-table.component";
import { SweetAlertDirective } from "projects/common/src/app/sweet-alert.directive";
import { TcAddressContactDetailsComponent } from "projects/common/src/app/tc-address-contact-details/tc-address-contact-details.component";
import { TcAnalticsComponent } from "projects/common/src/app/tc-analtics/tc-analtics.component";
import { TcRegistrationRuleFormComponent } from "projects/common/src/app/tc-registration-rule-form/tc-registration-rule-form.component";
import { ThankyouPaymentComponent } from "projects/common/src/app/thankyou-payment/thankyou-payment.component";
import { TimePickerComponent } from "projects/common/src/app/time-picker/time-picker.component";
import { TotToaDataFilterComponent } from "projects/common/src/app/tot-toa-data-filter/tot-toa-data-filter.component";
import { TotToaFilterComponent } from "projects/common/src/app/tot-toa-filter/tot-toa-filter.component";
import { TpRegistrationRuleFormComponent } from "projects/common/src/app/tp-registration-rule-form/tp-registration-rule-form.component";
import { TransLateModule } from "projects/common/src/app/translation/translte.module";
import { UploadDocumentComponent } from "projects/common/src/app/upload-document/upload-document.component";
import { UploadFileComponent } from "projects/common/src/app/upload-file/upload-file.component";
import { ViewAllDapCandidatesComponent } from "projects/common/src/app/view-all-dap-candidates/view-all-dap-candidates.component";
import { ViewApplicantDetailsComponent } from "projects/common/src/app/view-applicant-details/view-applicant-details.component";
import { ViewBatchDetailsApplicantComponent } from "projects/common/src/app/view-batch-details-applicant/view-batch-details-applicant.component";
import { ViewBatchesForApplicantComponent } from "projects/common/src/app/view-batches-for-applicant/view-batches-for-applicant.component";
import { ViewCaafDetailsComponent } from "projects/common/src/app/view-caaf-details/view-caaf-details.component";
import { ViewDeactivationRequestStatusComponent } from "projects/common/src/app/view-deactivation-request-status/view-deactivation-request-status.component";
import { ViewRozgarMelasFilterComponent } from "projects/common/src/app/view-rozgar-melas-filter/view-rozgar-melas-filter.component";
import { ViewTcResidentialDetailsComponent } from "projects/desktop-assessor/src/app/desktop-assessor/view-tc-residential-details/view-tc-residential-details.component";
import { PlacedCandidatesComponent } from "projects/employer/src/app/employer/view-rozgar-mela-details-dashboard/placed-candidates/placed-candidates.component";
import { TpFeedbackFormComponent } from "projects/feebased-pmkvy-shared/src/app/feebased-pmkvy-shared/fb-all-tps/tp-feedback-form/tp-feedback-form.component";
import { CandidateFeedbackComponent as CMFDACanFeedbackComponent } from "projects/feebased-pmkvy-shared/src/app/feebased-pmkvy-shared/fb-view-batch-details/candidate-feedback/candidate-feedback.component";
import { FormErrorControlModule } from "projects/form-error-control/src/app/form-error-control/form-error-control.module";
import { ViewTcRegirationCaafDetailsComponent } from "projects/inspection-agency/src/app/inspection-agency/view-tc-regiration-caaf-details/view-tc-regiration-caaf-details.component";
import { PmkvyBioMetricAttendanceComponent } from "projects/pmkvy/src/app/pmkvy/pmkvy-bio-metric-attendance/pmkvy-bio-metric-attendance.component";
import { ProfileViewAssessmentAgencyComponent } from "projects/ssc/src/app/ssc/link-assessment-agency/view-assessment-agency/profile-view-assessment-agency/profile-view-assessment-agency.component";
import { ViewTrainerDetailsComponent } from "projects/tc-registration-form/src/app/view-trainer-details/view-trainer-details.component";
import { CandidateMarksheetComponent } from "projects/training-center/src/app/candidate-marksheet/candidate-marksheet.component";
import { MessageCentreComponent } from "projects/training-center/src/app/training-of-trainers/tc-edit-caaf/message-centre/message-centre.component";
import { PaymentHistoryComponent } from "projects/training-center/src/app/training-of-trainers/tc-edit-caaf/payment-history/payment-history.component";
import { ViewCandidateDetailsInfoComponent } from "projects/training-partner/src/app/training-partner/common/view-candidate-details-info/view-candidate-details-info.component";
import { MsgCentreTpComponent } from "projects/training-partner/src/app/training-partner/msg-centre-tp/msg-centre-tp.component";
import { TpSchemeBankDetailsComponent } from "projects/training-partner/src/app/training-partner/tp-scheme-bank-details/tp-scheme-bank-details.component";
import { PipesModule } from "src/app/pipes/pipes.module";
import { AddTrainerComponent } from "./shared/add-trainer/add-trainer.component";
import { TrainerContactDetailsComponent } from "./shared/add-trainer/contact-details/contact-details.component";
import { TrainerDeclarationComponent } from "./shared/add-trainer/declaration/declaration.component";
import { TrainerEducationComponent } from "./shared/add-trainer/education/education.component";
import { TrainerPersonalInfoComponent } from "./shared/add-trainer/personal-info/personal-info.component";
import { TrainerPreferencesComponent } from "./shared/add-trainer/preferences/preferences.component";
import { VerifyOtpModalComponent } from "./shared/verify-otp-modal/verify-otp-modal.component";
import { AsideNavComponent } from "./theme/aside-nav/aside-nav.component";
import { FooterComponent } from "./theme/footer/footer.component";
import { HeaderNavComponent } from "./theme/header-nav/header-nav.component";
import { ScrollTopComponent } from "./theme/scroll-top/scroll-top.component";
import { ToolTipsComponent } from "./theme/tool-tips/tool-tips.component";
import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { LocationSearchWithMapsComponent } from "projects/common/src/app/location-search-with-maps/location-search-with-maps.component";

@NgModule({
  declarations: [
    AsideNavComponent,
    FooterComponent,
    HeaderNavComponent,
    ScrollTopComponent,
    DFormInputComponent,
    ToolTipsComponent,
    MessageCentreComponent,
    PaginationComponent,
    PaginationTwoComponent,
    SearchComponent,
    BreadcrumsComponent,
    TcRegistrationRuleFormComponent,
    CommonHeadersComponent,
    TpRegistrationRuleFormComponent,
    DisplayResultComponent,
    UploadDocumentComponent,
    UploadFileComponent,
    TotToaFilterComponent,
    BatchAttendenceComponent,
    FileDownloadComponent,
    DatePickerComponent,
    TimePickerComponent,
    DFormComponent,
    TextComponent,
    SimpleTextComponent,
    CheckboxComponent,
    SelectComponent,
    UploadComponent,
    AddressFormComponent,
    DFormGroupComponent,
    DateDurationComponent,
    DashboardComponent,
    CandidateMarksheetComponent,
    DashboardCardComponent,
    DashboardTitleComponent,
    AddressComponent,
    GeoLocationComponent,
    StripedRowsTableComponent,
    AddTrainerComponent,
    TrainerContactDetailsComponent,
    TrainerDeclarationComponent,
    TrainerEducationComponent,
    TrainerPersonalInfoComponent,
    TrainerPreferencesComponent,
    ThankyouPaymentComponent,
    // offeredJobVacancy,
    AddingTcComponent,
    ReviewCommentsComponent,
    GenericDirective,
    ReviewTypeComponent,
    TableComponent,
    TableTwoComponent,
    AddSectorComponent,
    AddCourseToSectorComponent,
    LinkTrainerComponent,
    LinkAssessorComponent,
    FileUploadComponent,
    PhoneEmailOtpVerificationComponent,
    AadharComponent,
    DFormArrayComponent,
    DGeoLocationComponent,
    InputGroupComponent,
    RadioComponent,
    ViewRozgarMelasFilterComponent,
    MultiTabTableComponent,
    AddSectorTargetComponent,
    AddSectorTargetFormComponent,
    SelectStateDistrictsComponent,
    InfoWidgetComponent,
    InfoWidgetGroupComponent,
    SweetAlertDirective,
    TcAnalticsComponent,
    SearchApplicantComponent,
    SearchResultForApplicantComponent,
    ApplicantPreferencesComponent,
    ViewBatchDetailsApplicantComponent,
    ViewBatchesForApplicantComponent,
    ViewApplicantDetailsComponent,
    TotToaDataFilterComponent,
    PlacedCandidatesComponent,
    FacilitySelectUploadAddingTcComponent,
    ImageSliderComponent,
    ApplicantAddCertificateComponent,
    ViewCandidateDetailsInfoComponent,
    TcAddressContactDetailsComponent,
    AaDetailsComponent,
    ApplicantCertificationListComponent,
    ApplicantAddCertificateComponent,
    ViewCaafDetailsComponent,
    PaymentHistoryComponent,
    ViewTrainerDetailsComponent,
    VerifyOtpModalComponent,
    ViewTcRegirationCaafDetailsComponent,
    MprListComponent,
    ViewTcPhotosThroughMobileApkReviewAndSubmitComponent,
    ViewTcResidentialDetailsComponent,
    // CertificateCeremonyDetailsComponent,
    AaProfileComponent,
    ProfileViewAssessmentAgencyComponent,
    PmkvyBioMetricAttendanceComponent,
    TpSchemeBankDetailsComponent,
    // ListTrainersAssessorsComponent
    ExpoSearchBoxComponent,
    MsgCentreTpComponent,
    CandidateFeedbackComponent,
    CpacFormComponent,
    TpFeedbackFormComponent,
    TrainerFeedbackFormComponent,
    CMFDACanFeedbackComponent,
    TpFeedbackFormComponent,
    TpFeedBackFormComponent,
    EvidenceSubmissionComponent,
    AaAuditTrailComponent,
    ApplicantAdvanceCertificationComponent,
    ViewAllDapCandidatesComponent,
    ChangeSpocComponent,
    ChangePasswordComponent,
    ViewDeactivationRequestStatusComponent,
    LocationSearchWithMapsComponent
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    AngularMultiSelectModule,
    PipesModule,
    FormErrorControlModule,
    RouterModule,
    CommonModule,
    // SlideshowModule,
    TransLateModule,
    GooglePlaceModule,
    NgbModule,
  ],
  exports: [
    AsideNavComponent,
    FormErrorControlModule,
    RouterModule,
    FooterComponent,
    NgbModule,
    HeaderNavComponent,
    ScrollTopComponent,
    CandidateMarksheetComponent,
    ToolTipsComponent,
    FormsModule,
    ReactiveFormsModule,
    MessageCentreComponent,
    SimpleTextComponent,
    PaginationComponent,
    PaginationTwoComponent,
    GooglePlaceModule,
    SearchComponent,
    BreadcrumsComponent,
    BatchAttendenceComponent,
    TableTwoComponent,
    ReviewTypeComponent,
    TpRegistrationRuleFormComponent,
    TcRegistrationRuleFormComponent,
    CommonHeadersComponent,
    DisplayResultComponent,
    UploadDocumentComponent,
    UploadFileComponent,
    TotToaFilterComponent,
    FileDownloadComponent,
    DatePickerComponent,
    TimePickerComponent,
    DFormComponent,
    TextComponent,
    CheckboxComponent,
    SelectComponent,
    AddressFormComponent,
    DFormGroupComponent,
    DateDurationComponent,
    DashboardComponent,
    DashboardCardComponent,
    DashboardTitleComponent,
    // offeredJobVacancy,
    AddressComponent,
    GeoLocationComponent,
    StripedRowsTableComponent,
    AddTrainerComponent,
    ThankyouPaymentComponent,
    TransLateModule,
    ReviewCommentsComponent,
    AddingTcComponent,
    GenericDirective,
    TableComponent,
    MultiTabTableComponent,
    AddSectorComponent,
    AddCourseToSectorComponent,
    LinkTrainerComponent,
    LinkAssessorComponent,
    FileUploadComponent,
    PhoneEmailOtpVerificationComponent,
    AadharComponent,
    DFormArrayComponent,
    RadioComponent,
    AddSectorTargetComponent,
    AddSectorTargetFormComponent,
    ViewRozgarMelasFilterComponent,
    SelectStateDistrictsComponent,
    InfoWidgetComponent,
    InfoWidgetGroupComponent,
    SweetAlertDirective,
    TcAnalticsComponent,
    SearchApplicantComponent,
    SearchResultForApplicantComponent,
    ApplicantPreferencesComponent,
    ViewBatchDetailsApplicantComponent,
    ViewBatchesForApplicantComponent,
    ViewApplicantDetailsComponent,
    TotToaDataFilterComponent,
    PlacedCandidatesComponent,
    FacilitySelectUploadAddingTcComponent,
    ApplicantAddCertificateComponent,
    ApplicantCertificationListComponent,
    ViewCandidateDetailsInfoComponent,
    TcAddressContactDetailsComponent,
    AaDetailsComponent,
    ViewCaafDetailsComponent,
    PaymentHistoryComponent,
    ViewTrainerDetailsComponent,
    VerifyOtpModalComponent,
    PipesModule,
    ImageSliderComponent,
    MprListComponent,
    ViewTcPhotosThroughMobileApkReviewAndSubmitComponent,
    ViewTcResidentialDetailsComponent,
    // CertificateCeremonyDetailsComponent,
    AaProfileComponent,
    ProfileViewAssessmentAgencyComponent,
    PmkvyBioMetricAttendanceComponent,
    TpSchemeBankDetailsComponent,
    // ListTrainersAssessorsComponent
    ExpoSearchBoxComponent,
    MsgCentreTpComponent,
    CandidateFeedbackComponent,
    CpacFormComponent,
    TpFeedBackFormComponent,
    TrainerFeedbackFormComponent,
    CMFDACanFeedbackComponent,
    TpFeedbackFormComponent,
    EvidenceSubmissionComponent,
    AaAuditTrailComponent,
    ApplicantAdvanceCertificationComponent,
    ViewAllDapCandidatesComponent,
    ViewDeactivationRequestStatusComponent,
    LocationSearchWithMapsComponent
  ],
})
export class SharedModule {}
